<template>
  <div class="comment-page">
    <top-bar :topbarList="commentTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { commentIndexMixins } from "@/mixins/commentIndexMixins";

export default {
  mixins: [commentIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.comment-page {
  height: 100%;
}
</style>
